import PropTypes from 'prop-types';
import RSelect from 'react-select';
import { ArrowDownIcon, ArrowUpIcon } from '~/components/icons';

import customStyles from './styles';

// eslint-disable-next-line react/prop-types
const DropdownIndicator = ({ innerRef, innerProps, selectProps = {} }) => {
  const ArrowIcon = selectProps?.menuIsOpen ? ArrowUpIcon : ArrowDownIcon;
  return (
    <ArrowIcon boxSize={2} color="primary.300" ref={innerRef} {...innerProps} />
  );
};

const propTypes = {
  components: PropTypes.shape({}),
  hasError: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
};

export const Select = ({
  components = {},
  hasError = false,
  size = 'md',
  ...remainingProps
}) => (
  <RSelect
    components={{ DropdownIndicator, ...components }}
    hasError={hasError}
    menuPlacement="auto"
    styles={customStyles(size)}
    {...remainingProps}
  />
);

Select.propTypes = propTypes;
